import { render, staticRenderFns } from "./KitchenSummary.vue?vue&type=template&id=7363492e&scoped=true"
import script from "./KitchenSummary.vue?vue&type=script&lang=js"
export * from "./KitchenSummary.vue?vue&type=script&lang=js"
import style0 from "./KitchenSummary.vue?vue&type=style&index=0&id=7363492e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363492e",
  null
  
)

export default component.exports